import { createSlice } from '@reduxjs/toolkit';

const stripeFee = createSlice({
  name: 'stripeFeeStatus',
  initialState: {
    status: "Company",
  },
  reducers: {
    setStripeFee: (state, action) => {
      state.status = action.payload;
    },
    clearStripeFee: (state) => {
      state.status = "Company";
    },
  },
});

export const { setStripeFee, clearStripeFee } = stripeFee.actions;

export default stripeFee.reducer;
